import { SagaIterator } from "redux-saga";
import { call, put, takeLatest } from "redux-saga/effects";
import { IResponse } from "../../../../libs/requester/IResponse";
import { requester } from "../../../../libs/requester/requester-axios";
import { setUploadReportError, setLoading } from "../../repository/slice";

function* uploadReportWorker({ payload }: any): SagaIterator {
    try {
        yield put(setLoading(true));
        const { data, message, isError }: IResponse<any> = yield call(requester.get, "/api/excel/document-report/" + payload.id);
        if (isError) {
            yield put(setUploadReportError(message));
        } else {
            yield put(setUploadReportError(null));
            const downloadLink = document.createElement("a");
            downloadLink.href = data.url;
            downloadLink.click();
        }
    } catch (error) {
        console.error("uploadReportWorker: ", error);
    } finally {
        yield put(setLoading(false));
    };
};

export function* uploadReportWatcher() {
    yield takeLatest("@saga/UPLOAD_REPORT", uploadReportWorker);
};
